module.exports = __webpack_public_path__ + "static/media/Diagram.20994cad.png";